enum PromotionGroupType {
    ServiceAward = 'ServiceAward',
    Normal = 'Normal',
}

export default PromotionGroupType;
